import { Statute } from '../types/Statute.type';

export interface EnhancementDyad {
  id: string;
  baseStatute: Statute;
  enhancementStatute: Statute;
  label: string;
}

export function splitEnhancementGroup(group: Statute[]): { enhancements: Statute[]; bases: Statute[] } {
  const enhancements: Statute[] = [];
  const bases: Statute[] = [];
  for (const s of group) {
    if (s.is_charge_enhancement) enhancements.push(s);
    else bases.push(s);
  }
  return { enhancements, bases };
}

export function createEnhancementDyadsFromCase(caseData?: {
  charge_enhancements?: Statute[][] | null;
}): EnhancementDyad[] {
  const groups = caseData?.charge_enhancements;
  if (!groups?.length) return [];
  const result: EnhancementDyad[] = [];
  for (const group of groups) {
    const { enhancements, bases } = splitEnhancementGroup(group);
    for (const enh of enhancements) {
      for (const base of bases) {
        result.push({
          id: `${base.id}-${enh.id}`,
          baseStatute: base,
          enhancementStatute: enh,
          label: `${base.display_name} + ${enh.display_name}`,
        });
      }
    }
  }
  return result;
}

export function findDyadByStatuteIds(dyads: EnhancementDyad[], ids: Iterable<number>): EnhancementDyad | null {
  const idSet = ids instanceof Set ? ids : new Set(ids);
  return dyads.find((d) => idSet.has(d.baseStatute.id) && idSet.has(d.enhancementStatute.id)) ?? null;
}
